/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid hex colour to generate a palette.`)
};

const es_cp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce un color hexadecimal válido para generar una paleta.`)
};

const de_cp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib eine gültige Hex-Farbe ein, um eine Palette zu erzeugen.`)
};

const nl_cp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul een geldige hexkleur in om een palet te genereren.`)
};

const fr_cp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez une couleur hexadécimale valide pour générer une palette.`)
};

const it_cp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un colore esadecimale valido per generare una palette.`)
};

const pt_br2_cp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe uma cor hex válida para gerar uma paleta.`)
};

const pt_cp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza uma cor hex válida para gerar uma paleta.`)
};

const ja_cp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パレットを生成するには有効な16進数カラーを入力してください。`)
};

const zh_cp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入有效的十六进制颜色以生成配色方案。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_hint", locale)
	if (locale === "en") return en_cp_hint(inputs)
	if (locale === "es") return es_cp_hint(inputs)
	if (locale === "de") return de_cp_hint(inputs)
	if (locale === "nl") return nl_cp_hint(inputs)
	if (locale === "fr") return fr_cp_hint(inputs)
	if (locale === "it") return it_cp_hint(inputs)
	if (locale === "pt-BR") return pt_br2_cp_hint(inputs)
	if (locale === "pt") return pt_cp_hint(inputs)
	if (locale === "ja") return ja_cp_hint(inputs)
	return zh_cp_hint(inputs)
};